import { IconError } from "@icons/index";
import CommonButton from "@components/CommonButton";
import { Trans } from "react-i18next";

interface ErrorBoundaryFallbackProps {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}

export const ErrorBoundaryFallback = ({ eventId, resetError }: ErrorBoundaryFallbackProps) => {
  const handleReload = () => {
    if (resetError) {
      resetError();
    } else {
      window.location.reload();
    }
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4" style={{ backgroundColor: "var(--kds-bg)" }}>
      <div className="flex max-w-md flex-col items-center text-center">
        <IconError className="mb-6 h-20 w-20" />

        <h1 className="mb-2 text-2xl font-semibold" style={{ color: "var(--kds-fg)" }}>
          <Trans>Something went wrong</Trans>
        </h1>

        <p className="mb-8 text-base" style={{ color: "var(--kds-fg-subtle)" }}>
          <Trans>
            We're sorry, the page encountered an error. Please try reloading the page or return to the homepage.
          </Trans>
        </p>

        <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
          <CommonButton type="primary" onClick={handleReload} className="min-w-[140px]">
            <Trans>Reload page</Trans>
          </CommonButton>
          <CommonButton type="default" onClick={handleGoHome} className="min-w-[140px]">
            <Trans>Go to homepage</Trans>
          </CommonButton>
        </div>

        {eventId && (
          <div className="mt-6 text-xs" style={{ color: "var(--kds-fg-muted)" }}>
            <Trans>Event ID</Trans>: {eventId}
          </div>
        )}
      </div>
    </div>
  );
};
